export { default } from "./GTMViewCart";
